import { get, isNaN, parseInt } from 'lodash-es';

const byInitialPage = (state: any) => {
  const page = parseInt(get(state, 'resultList.searchQuery.page'));
  return isNaN(page) ? 0 : page - 1;
};

export default byInitialPage;
